var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'led',
    { 'led-red': _vm.status === 'Offen' },
    { 'led-orange': _vm.status === 'in Bearbeitung' },
    { 'led-green': _vm.status === 'erledigt' }
  ]})
}
var staticRenderFns = []

export { render, staticRenderFns }